var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 242.245,
    height: 170.396,
    viewBox: "0 0 242.245 170.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.227,
    x2: 0.5,
    y2: 0.559,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1546",
    "data-name": "Group 1546",
    transform: "translate(-276.437 -709.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1547",
    "data-name": "Group 1547"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1545",
    "data-name": "Group 1545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1543",
    "data-name": "Group 1543",
    transform: "translate(20.883 623.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044",
    transform: "translate(255.554 86.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M502.808,189.618c-11.263-13.527-32.784-15.487-46.3-26.949-14.642-12.413-18.45-29.952-31.029-44.289-5.246-5.98-11.224-14.454-18.36-18.367-6.428-3.525-13.363-6.6-21.078-7.2a40.971,40.971,0,0,0-28.177,9.139c-7.88,6.377-13.554,15.6-22.69,19.9-11.474,5.395-23.8,1.532-35.006.747-13.1-.918-26.694,6.346-31.149,18.585-2,5.487-2,11.484-1.087,17.228.935,5.851,2.915,11.779,6.787,16.478,4.089,4.964,9.488,8.747,13.078,14.149,4.257,6.406,3.914,15.053,2.515,23.138s-3.737,16.288-3.038,24.2a29.153,29.153,0,0,0,20.457,25.1c14.531,4.528,31.521-1.173,46.966-7.053,13.829-5.265,29.8-11.431,44.237-10.444,15.225,1.041,27.776,10.689,42.245,13.895,18.517,4.1,40.993-1.762,55.2-16.469S514.262,203.374,502.808,189.618Z",
    transform: "translate(-267.338 -92.715)",
    fill: "#d9daee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034",
    transform: "translate(24.739 20.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012",
    transform: "translate(37.312 41.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M435.39,262.569a.143.143,0,0,1-.014-.055.141.141,0,0,1,.133-.148q.349-.019.7-.055a.141.141,0,1,1,.029.28c-.236.024-.472.043-.71.056A.141.141,0,0,1,435.39,262.569Z",
    transform: "translate(-435.375 -262.31)",
    fill: "#B8C7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M338.034,177.045q-.215-.437-.423-.877a.141.141,0,0,1,.067-.188.139.139,0,0,1,.188.067q.3.634.616,1.265h0a.141.141,0,0,1-.253.126C338.165,177.307,338.1,177.176,338.034,177.045Zm.843,1.646a.141.141,0,0,1,.251-.128q.33.622.671,1.238a.138.138,0,0,1-.055.192.141.141,0,0,1-.192-.055q-.342-.618-.673-1.243Zm-1.849-3.8,0-.006c-.192-.439-.377-.878-.547-1.3a.141.141,0,1,1,.261-.1c.169.424.352.86.543,1.3a.141.141,0,0,1-.256.119Zm3.214,6.272a.141.141,0,0,1,.249-.132q.352.613.709,1.217a.144.144,0,0,1-.049.193.142.142,0,0,1-.194-.049q-.358-.606-.71-1.22Zm-4.258-8.891a.109.109,0,0,1-.007-.015c-.162-.453-.314-.9-.45-1.342a.141.141,0,1,1,.269-.084c.135.434.285.881.446,1.331a.141.141,0,0,1-.259.11Zm-.838-2.691a.13.13,0,0,1-.01-.027c-.121-.465-.23-.929-.324-1.379a.141.141,0,0,1,.276-.057c.092.446.2.905.321,1.365a.141.141,0,0,1-.263.1Zm-.569-2.76a.144.144,0,0,1-.013-.042c-.07-.475-.124-.948-.163-1.409a.141.141,0,0,1,.281-.023c.038.455.092.923.161,1.391a.141.141,0,0,1-.266.083Zm-.229-2.808a.132.132,0,0,1-.014-.06c-.006-.476,0-.954.034-1.419a.141.141,0,0,1,.281.017c-.028.459-.04.929-.033,1.4a.141.141,0,0,1-.267.064Zm.176-2.811a.14.14,0,0,1-.013-.082c.067-.469.154-.939.258-1.4a.141.141,0,1,1,.275.063c-.1.451-.188.913-.253,1.374a.141.141,0,0,1-.266.042Zm.626-2.746a.139.139,0,0,1-.008-.1c.1-.317.212-.635.332-.947q.075-.195.154-.388a.141.141,0,1,1,.261.107q-.078.191-.151.382c-.117.306-.227.62-.326.931a.141.141,0,0,1-.261.02Zm1.069-2.606a.14.14,0,0,1,0-.126c.219-.43.456-.846.7-1.237a.141.141,0,0,1,.238.151c-.243.383-.475.791-.691,1.214a.141.141,0,0,1-.19.061A.139.139,0,0,1,336.219,155.845Zm1.513-2.375a.142.142,0,0,1,.016-.15,11.836,11.836,0,0,1,.952-1.062.141.141,0,1,1,.2.2,11.645,11.645,0,0,0-.929,1.037.141.141,0,0,1-.2.023A.146.146,0,0,1,337.732,153.47Zm2.007-1.97a.141.141,0,0,1,.042-.175,10.373,10.373,0,0,1,1.2-.776.141.141,0,0,1,.192.055.138.138,0,0,1-.055.192,10.048,10.048,0,0,0-1.167.755.142.142,0,0,1-.2-.028A.161.161,0,0,1,339.738,151.5Zm2.458-1.366,0-.011a.141.141,0,0,1,.08-.183,11.666,11.666,0,0,1,1.357-.439.139.139,0,0,1,.172.1.141.141,0,0,1-.1.172,11.528,11.528,0,0,0-1.324.429A.14.14,0,0,1,342.2,150.134Zm2.723-.708a.139.139,0,0,1-.013-.043.141.141,0,0,1,.12-.159,13.608,13.608,0,0,1,1.419-.123.141.141,0,1,1,.01.282,13.353,13.353,0,0,0-1.39.121A.141.141,0,0,1,344.92,149.426Zm2.814-.1a.141.141,0,0,1,.136-.2c.469.03.945.084,1.414.159a.141.141,0,0,1-.045.279c-.46-.074-.927-.127-1.387-.157A.141.141,0,0,1,347.734,149.326Zm2.781.446a.141.141,0,0,1,.161-.2c.458.118.915.258,1.36.418a.141.141,0,1,1-.1.266c-.436-.157-.885-.3-1.335-.411A.14.14,0,0,1,350.515,149.771Zm2.651.952a.141.141,0,0,1,.186-.191c.424.2.849.414,1.264.646a.141.141,0,1,1-.138.246c-.41-.229-.828-.443-1.245-.636A.143.143,0,0,1,353.166,150.724Zm20.59,40.176a.14.14,0,0,1,.1-.2c.453-.089.909-.2,1.357-.331a.139.139,0,0,1,.175.1.141.141,0,0,1-.1.175c-.456.133-.921.246-1.382.337A.14.14,0,0,1,373.756,190.9Zm-18.131-38.8a.141.141,0,0,1,.2-.18c.388.256.778.532,1.159.819a.141.141,0,0,1-.171.225c-.375-.284-.76-.556-1.143-.809A.14.14,0,0,1,355.625,152.1Zm2.25,1.7a.141.141,0,0,1,.218-.17c.352.3.706.621,1.052.95a.141.141,0,0,1-.195.2c-.342-.326-.693-.642-1.041-.94A.138.138,0,0,1,357.874,153.8Zm18.586,36.317,0-.011a.141.141,0,0,1,.08-.182c.431-.167.862-.355,1.282-.559a.141.141,0,0,1,.188.064h0a.141.141,0,0,1-.065.189c-.427.208-.865.4-1.3.569A.141.141,0,0,1,376.461,190.114ZM359.92,155.738a.141.141,0,0,1,.228-.16c.317.332.639.683.957,1.044a.141.141,0,1,1-.212.186c-.315-.358-.635-.707-.949-1.035A.149.149,0,0,1,359.92,155.738Zm1.863,2.117a.141.141,0,0,1,.236-.151c.29.356.585.73.875,1.111a.139.139,0,0,1-.027.2.141.141,0,0,1-.2-.027c-.289-.379-.582-.75-.87-1.1A.141.141,0,0,1,361.783,157.854Zm1.717,2.237a.141.141,0,0,1,.24-.146c.278.374.56.751.849,1.123a.141.141,0,0,1-.223.173c-.29-.374-.573-.752-.853-1.128A.131.131,0,0,1,363.5,160.092Zm1.741,2.22a.141.141,0,0,1,.233-.154c.33.383.642.717.954,1.021a.141.141,0,1,1-.2.2c-.318-.31-.636-.65-.971-1.038A.167.167,0,0,1,365.241,162.311Zm13.753,26.569a.141.141,0,0,1,.055-.184c.4-.236.793-.492,1.174-.76a.141.141,0,1,1,.163.23c-.386.273-.788.533-1.193.773a.141.141,0,0,1-.193-.049Zm-11.723-24.619a.141.141,0,0,1,.211-.175,7.9,7.9,0,0,0,1.172.734.141.141,0,1,1-.127.251,8.135,8.135,0,0,1-1.214-.76A.143.143,0,0,1,367.271,164.262Zm2.508,1.244a.143.143,0,0,1-.01-.1.141.141,0,0,1,.172-.1c.09.023.181.045.273.064a6.461,6.461,0,0,0,1.089.131.141.141,0,1,1-.011.281,6.84,6.84,0,0,1-1.137-.137c-.1-.02-.191-.042-.285-.066A.14.14,0,0,1,369.779,165.506Zm11.516,21.75a.141.141,0,0,1,.036-.171c.357-.3.706-.612,1.039-.937a.141.141,0,1,1,.2.2c-.338.33-.693.65-1.055.952a.141.141,0,0,1-.2-.018A.165.165,0,0,1,381.3,187.256Zm-8.717-21.613a.136.136,0,0,1-.014-.046.141.141,0,0,1,.124-.156c.406-.047.845-.118,1.381-.224a.141.141,0,0,1,.055.277c-.543.107-.989.18-1.4.227A.14.14,0,0,1,372.579,165.643Zm10.733,19.644a.141.141,0,0,1,.02-.155c.306-.351.6-.718.876-1.09a.141.141,0,1,1,.227.167c-.279.379-.579.751-.89,1.108a.141.141,0,0,1-.2.013A.147.147,0,0,1,383.311,185.287Zm-7.961-20.162a.127.127,0,0,1-.011-.033.141.141,0,0,1,.108-.167c.441-.095.915-.193,1.39-.273a.141.141,0,1,1,.046.278c-.469.078-.939.176-1.377.27A.14.14,0,0,1,375.351,165.126Zm9.634,17.895a.141.141,0,0,1,.006-.136c.246-.4.475-.808.683-1.22a.141.141,0,0,1,.252.127c-.212.419-.445.836-.695,1.241a.141.141,0,0,1-.194.046A.138.138,0,0,1,384.984,183.02Zm-6.85-18.329a.143.143,0,0,1-.014-.055.141.141,0,0,1,.133-.148,8.359,8.359,0,0,1,.957,0q.239.014.475.043a.141.141,0,1,1-.035.28q-.227-.028-.457-.042a8.229,8.229,0,0,0-.925,0A.14.14,0,0,1,378.134,164.692Zm8.119,15.814a.141.141,0,0,1,0-.114c.173-.434.328-.878.458-1.319a.141.141,0,0,1,.27.08c-.133.449-.29.9-.466,1.344a.141.141,0,0,1-.183.079A.138.138,0,0,1,386.253,180.505Zm.8-2.7a.139.139,0,0,1-.012-.089c.09-.459.16-.923.207-1.381a.141.141,0,0,1,.281.029c-.048.467-.119.94-.211,1.407a.141.141,0,0,1-.265.035Zm-6.137-12.765a.141.141,0,0,1,.17-.2,8.329,8.329,0,0,1,1.319.558.141.141,0,0,1-.131.25,7.985,7.985,0,0,0-1.275-.539A.143.143,0,0,1,380.915,165.04ZM387.336,175a.139.139,0,0,1-.014-.063,13.344,13.344,0,0,0-.067-1.393.141.141,0,0,1,.281-.028,13.6,13.6,0,0,1,.068,1.423.141.141,0,0,1-.267.062Zm-3.935-8.659a.141.141,0,0,1,.211-.175,9.527,9.527,0,0,1,1.074.945.141.141,0,0,1-.2.2,9.261,9.261,0,0,0-1.041-.917A.143.143,0,0,1,383.4,166.345Zm3.647,5.858a.162.162,0,0,1-.011-.032,11.167,11.167,0,0,0-.38-1.338.141.141,0,0,1,.086-.18.139.139,0,0,1,.18.086,11.362,11.362,0,0,1,.39,1.372.141.141,0,0,1-.264.093Zm-1.681-3.85a.141.141,0,0,1,.241-.145,9.532,9.532,0,0,1,.72,1.163l.029.056h0a.141.141,0,0,1-.252.127l-.027-.052a9.261,9.261,0,0,0-.7-1.13A.128.128,0,0,1,385.367,168.353Z",
    transform: "translate(-334.332 -149.101)",
    fill: "#B8C7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(7.347 34.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M354.242,242.228a.141.141,0,0,1,.247-.135q.182.3.366.6a.143.143,0,0,1-.047.194.141.141,0,0,1-.194-.047q-.183-.3-.366-.6Z",
    transform: "translate(-354.228 -242.025)",
    fill: "#B8C7FF"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023",
    transform: "translate(7.158 33.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(0 3.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M362.447,256.687l-5.514-9.008-3.216,2.131Z",
    transform: "translate(-353.717 -247.679)",
    fill: "#1ead9b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(0 5.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M362.447,259.958l-5.8-7.093-2.934.216Z",
    transform: "translate(-353.717 -252.865)",
    fill: "#2ebfaa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(3.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M367.941,251.319l-4.444-12.15-1.07,3.143Z",
    transform: "translate(-362.427 -239.169)",
    fill: "#B8C7FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(1.928 5.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M365.741,259.958l-5.8-7.093-1.006,3.851Z",
    transform: "translate(-358.938 -252.865)",
    fill: "#B8C7FF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033",
    transform: "translate(46.502 131.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M467.669,509.428c-2.463,0-3.437,1.017-3.437,3.207,0,.2-.383.2-.383,0,0-2.19-.779-3.207-3.437-3.207-.2,0-.2-.384,0-.384,2.74,0,3.437-1.268,3.437-3.2,0-.2.383-.2.383,0,0,2.3.933,3.2,3.437,3.2C467.868,509.044,467.868,509.428,467.669,509.428Z",
    transform: "translate(-460.263 -505.69)",
    fill: "#fad6e4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "translate(59.897 37.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M535.906,205.156v89.012a11.264,11.264,0,0,1-11.262,11.265H440.808a11.267,11.267,0,0,1-11.265-11.265V205.156a11.267,11.267,0,0,1,11.265-11.147h83.837A11.264,11.264,0,0,1,535.906,205.156Z",
    transform: "translate(-429.543 -194.009)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M535.906,205.156H429.543a11.267,11.267,0,0,1,11.265-11.147h83.837A11.264,11.264,0,0,1,535.906,205.156Z",
    transform: "translate(-429.543 -194.009)",
    fill: "#B8C7FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    transform: "translate(9.355 3.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 2.057,
    cy: 2.057,
    r: 2.057,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    transform: "translate(6.38)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 2.057,
    cy: 2.057,
    r: 2.057,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(12.759)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 2.057,
    cy: 2.057,
    r: 2.057,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    transform: "translate(32.477 3.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M558.332,207.646H519.549a2.057,2.057,0,0,1-2.057-2.058h0a2.057,2.057,0,0,1,2.057-2.057h38.782a2.057,2.057,0,0,1,2.058,2.057h0A2.058,2.058,0,0,1,558.332,207.646Z",
    transform: "translate(-517.492 -203.531)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051",
    transform: "translate(-723.229 293.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    transform: "translate(1069.453 480.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046",
    transform: "translate(11.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M1205.676,785.154a2.076,2.076,0,0,1-.485,2.536c-.723.753-1.458.636-1.793,1.3-.4.8.457,1.4.007,2.236-.276.517-.655.394-1.2,1.049-.668.8-.013,1.026-.487,1.61-1.523,1.878-2.134.575-3.061,1.069-1.2.64-2.006,1.186-2.595,1.058-2.313-.5-1.6-2.024-2.723-2.61-1.517-.792-2.258-4.033-1.217-5.175.545-.6,1.084-.671,1.135-1.169.073-.719-1.012-.928-1.122-1.793-.125-.981,1.176-1.456.983-2.284-.189-.808-1.525-.779-1.61-1.355-.13-.875,2.72-2.442,5.672-2.344,1.411.046,3.711.5,4.094,1.678.221.679-.354,1.117-.03,1.995a3.2,3.2,0,0,0,1.447,1.454C1203.342,784.847,1204.63,783.675,1205.676,785.154Z",
    transform: "translate(-1191.5 -779.279)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M1230.437,831.866c.464-.023.7,3.074.432,3.479s-.776.706-.809,1.149.164,8.3.328,8.184,1.524-2.172,1.252-2.651a3.45,3.45,0,0,1-.515-1.847c.064-.626.064-1.519.24-1.5s.028,1.559.151,1.857.143.531.318.536.179-1.621.446-1.593.086,2.425-.006,2.869a14.511,14.511,0,0,1-.7,2.539c-.29.564-1.172,1.155-1.193,1.348s.12,4.766.12,4.766l-2.31.042s.853-9.019.662-9.319-1.4-2.737-1.653-2.986a3.1,3.1,0,0,1-.276-1.789c.136-.022.212,1.459.5,1.483s.436-2.865.641-2.84-.2,3-.089,3.181.755,1.283.969,1.26-.118-8.111.066-8.2.322-.016.435.831a15.111,15.111,0,0,0,.458,2.693.693.693,0,0,0,.45-.467C1230.358,834.707,1230.23,831.876,1230.437,831.866Z",
    transform: "translate(-1223.315 -826.518)",
    fill: "#bdbdbd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    transform: "translate(68.903 11.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M1758.062,893.932a1.176,1.176,0,0,0,.275,1.436c.409.426.826.36,1.015.737.229.455-.258.79,0,1.266.156.293.371.223.682.594.378.452.007.581.276.912.862,1.063,1.208.326,1.733.605.681.362,1.136.672,1.469.6,1.309-.285.906-1.146,1.542-1.477a2.346,2.346,0,0,0,.689-2.93c-.309-.339-.614-.38-.643-.662-.042-.407.573-.525.635-1.015.071-.555-.666-.824-.556-1.293s.863-.441.912-.768c.073-.5-1.54-1.382-3.212-1.327-.8.026-2.1.284-2.318.95-.125.385.2.633.017,1.129a1.813,1.813,0,0,1-.819.824C1759.383,893.758,1758.654,893.094,1758.062,893.932Z",
    transform: "translate(-1757.91 -890.606)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M1789.065,920.379c-.263-.013-.4,1.74-.245,1.97s.439.4.458.651-.093,4.7-.186,4.633-.863-1.23-.709-1.5a1.954,1.954,0,0,0,.292-1.046c-.036-.355-.037-.86-.136-.848s-.016.883-.085,1.052-.081.3-.18.3-.1-.918-.253-.9-.049,1.373,0,1.624a8.184,8.184,0,0,0,.394,1.438c.164.319.664.654.676.763s-.068,2.7-.068,2.7l1.307.024s-.483-5.106-.375-5.276.79-1.549.936-1.69a1.754,1.754,0,0,0,.156-1.013c-.077-.013-.12.826-.28.84s-.247-1.622-.363-1.608.113,1.7.051,1.8-.427.727-.549.713.067-4.592-.037-4.644-.182-.009-.246.47a8.532,8.532,0,0,1-.259,1.525.392.392,0,0,1-.255-.264A8.433,8.433,0,0,0,1789.065,920.379Z",
    transform: "translate(-1784.92 -917.351)",
    fill: "#bdbdbd"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 43.945,
    cy: 15.557,
    rx: 43.945,
    ry: 15.557,
    transform: "translate(0 20.668)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "No_files",
    "data-name": "No files",
    transform: "translate(276.179 712.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1394",
    "data-name": "Group 1394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No_data",
    "data-name": "No data",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1548",
    "data-name": "Group 1548",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M97.571,98.292v9.8H95.752l-4.826-6.227V108.1H88.821v-9.8h1.825l4.826,6.235V98.292Z",
    fill: "#cfcfd0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M105.442,107.161a3.582,3.582,0,0,1-5.109,0,3.414,3.414,0,0,1,0-5,3.584,3.584,0,0,1,5.109,0,3.42,3.42,0,0,1,0,5Zm-3.735-1.2a1.6,1.6,0,0,0,2.365,0,1.926,1.926,0,0,0,0-2.587,1.592,1.592,0,0,0-2.365,0,1.926,1.926,0,0,0,0,2.587Z",
    fill: "#cfcfd0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M114.76,101.341a2.4,2.4,0,0,1,.721.479l.212.253V98.292h1.887v9.8h-1.887v-.841a.971.971,0,0,1-.086.107c-.038.043-.12.12-.246.232a2.9,2.9,0,0,1-.406.3,2.425,2.425,0,0,1-.568.235,2.529,2.529,0,0,1-.724.1,3.088,3.088,0,0,1-2.314-1.035,3.762,3.762,0,0,1,0-5.067,3.088,3.088,0,0,1,2.314-1.035A2.49,2.49,0,0,1,114.76,101.341Zm.441,4.683a2.123,2.123,0,0,0,0-2.718,1.6,1.6,0,0,0-2.379,0,2.123,2.123,0,0,0,0,2.718,1.594,1.594,0,0,0,2.379,0Z",
    fill: "#cfcfd0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M123.246,107.4c-.055.063-.131.142-.228.236a2.772,2.772,0,0,1-.64.369,2.6,2.6,0,0,1-2.693-.342,1.786,1.786,0,0,1-.643-1.384,1.942,1.942,0,0,1,.541-1.4,2.647,2.647,0,0,1,1.49-.731l2.173-.39a.89.89,0,0,0-.314-.7,1.29,1.29,0,0,0-.875-.273,2.029,2.029,0,0,0-.848.174,1.578,1.578,0,0,0-.54.359l-.157.164-1.046-1.046.113-.147a3.813,3.813,0,0,1,.865-.717,3.574,3.574,0,0,1,.772-.322,3.31,3.31,0,0,1,.977-.147,2.96,2.96,0,0,1,2.119.775,2.575,2.575,0,0,1,.821,1.953V108.1h-1.887Zm-.379-1.112a1.589,1.589,0,0,0,.379-1.13v-.212l-1.538.28q-.772.123-.772.772,0,.7.909.7A1.329,1.329,0,0,0,122.867,106.286Z",
    fill: "#cfcfd0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M127.792,99.208h1.682v2.167h1.394v1.682h-1.394v2.728a.729.729,0,0,0,.236.546.827.827,0,0,0,.6.226,1.7,1.7,0,0,0,.359-.038,1.357,1.357,0,0,0,.263-.078l.082-.028v1.614a3.453,3.453,0,0,1-1.265.205q-2.166,0-2.167-2.379v-2.8h-1.189v-1.682h.629a.7.7,0,0,0,.546-.253.946.946,0,0,0,.226-.656Z",
    fill: "#cfcfd0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M136.118,107.4c-.055.063-.131.142-.228.236a2.772,2.772,0,0,1-.64.369,2.6,2.6,0,0,1-2.693-.342,1.786,1.786,0,0,1-.643-1.384,1.945,1.945,0,0,1,.54-1.4,2.657,2.657,0,0,1,1.49-.731l2.174-.39a.89.89,0,0,0-.314-.7,1.29,1.29,0,0,0-.875-.273,2.029,2.029,0,0,0-.848.174,1.578,1.578,0,0,0-.54.359l-.157.164-1.046-1.046.113-.147a3.23,3.23,0,0,1,.321-.318,3.344,3.344,0,0,1,.543-.4,3.628,3.628,0,0,1,.773-.322,3.31,3.31,0,0,1,.977-.147,2.964,2.964,0,0,1,2.12.775,2.578,2.578,0,0,1,.82,1.953V108.1h-1.887Zm-.379-1.112a1.589,1.589,0,0,0,.379-1.13v-.212l-1.538.28q-.772.123-.772.772,0,.7.909.7A1.327,1.327,0,0,0,135.739,106.286Z",
    fill: "#cfcfd0"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/No data.880e15ffbf1c0a8cb340a54083561237.svg";
export { ForwardRef as ReactComponent };